import React, { FC, useState } from 'react'
import { cls } from '@utils/classnames'

import { isMobile } from '../../../utils/mediaQueries'
import { ProductUnitModal } from '../ProductUnitModal/ProductUnitModal'

type ProductUnit = {
  Title: string
  Category: string
  Image: string
  link?: string
  [key: string]: string | boolean | undefined // For dynamic features and machine compatibility fields
}

type ProductUnitproductUnit = {
  productUnit: ProductUnit
  backButtonLabel: string
  viewPageButtonLabel: string
  closeButtonLabel: string
}

export const ProductUnit: FC<ProductUnitproductUnit> = ({
  productUnit,
  backButtonLabel,
  viewPageButtonLabel,
  closeButtonLabel,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const isMobileView = isMobile()
  const Wrapper = productUnit.link ? 'a' : 'div'
  const classes = productUnit.link ? 'cmp-product-unit cmp-product-unit--is-link' : 'cmp-product-unit'

  const features = Object.entries(productUnit)
    .filter(([key, value]) => key.startsWith('Feature') && value && value !== '')
    .map(([, value]) => String(value))

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  return (
    <>
      <Wrapper
        {...(productUnit.link ? { href: productUnit.link } : {})}
        className={classes}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        {...(isMobileView && features.length > 0
          ? {
              onClick: (event_) => {
                event_.preventDefault()
                handleOpenModal()
              },
            }
          : {})}
      >
        <div className="cmp-product-unit__media">
          <div className={`cmp-product-unit__image ${isHovered ? 'cmp-product-unit__image--hidden' : ''}`}>
            <img src={productUnit.Image} alt={productUnit.Title} loading="lazy" />
          </div>

          {features.length > 0 ? (
            <div
              className={cls({
                'cmp-product-unit__features': true,
                'cmp-product-unit__features--visible': isHovered,
              })}
            >
              <ul className="cmp-product-unit__features-list">
                {features.map((feature, index) => (
                  <li key={index} className="cmp-product-unit__feature-item">
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="cmp-product-unit__no-features">
              <p>No features available</p>
            </div>
          )}
        </div>

        <div className="cmp-product-unit__content">
          <span className="cmp-product-unit__category">{productUnit.Category}</span>
          <h3 className="cmp-product-unit__title">
            {productUnit.Title}
            {productUnit.link ? <i className="ri-arrow-right-line cmp-product-unit__icon"></i> : ''}
          </h3>
        </div>
      </Wrapper>

      {isModalOpen && isMobileView && features.length > 0 && (
        <ProductUnitModal
          title={productUnit.Title}
          onClose={() => setIsModalOpen(false)}
          primaryButtonLabel={productUnit.link ? viewPageButtonLabel : closeButtonLabel}
          primaryButtonOnClick={
            /* eslint-disable  @typescript-eslint/no-non-null-assertion */
            productUnit.link ? () => (window.location.href = productUnit.link!) : () => setIsModalOpen(false)
          }
          {...(productUnit.link
            ? {
                secondaryButtonLabel: backButtonLabel,
                secondaryButtonOnClick: () => setIsModalOpen(false),
              }
            : {})}
        >
          <ul className="cmp-product-unit__modal-features-list">
            {features.map((feature, index) => (
              <li key={index} className="cmp-product-unit__feature-item">
                {feature}
              </li>
            ))}
          </ul>
        </ProductUnitModal>
      )}
    </>
  )
}
